import { archRententionOption } from '../../Question';

export default class ReadOnlyRetainerRequestHelper {
    constructor(getDiffRetainerLang, supportedRetainerTypes) {
        this.getDiffRetainerLang = getDiffRetainerLang || null;
        this.supportedRetainerTypes = supportedRetainerTypes || [];
    }

    getTranslatedSubOptions(subOption) {
        const subOptsValue = [
            'Round Twist Wire',
            'Flat Twist Wire',
            'placement jig in middle of wire',
            'placement jig on ends of the wire',
            'no placement jig',
            '4-4',
            '5-5',
            '6-6',
            '3-3',
            '2-2',
        ];
        if (!subOption || !subOptsValue.includes(subOption)) return '';

        switch (subOption) {
            case 'Round Twist Wire':
                return this.getDiffRetainerLang('subOptions.roundTwistWire');
            case 'Flat Twist Wire':
                return this.getDiffRetainerLang('subOptions.flatTwistWire');
            case 'placement jig in middle of wire':
                return this.getDiffRetainerLang('subOptions.placementJigInMiddleOfWire');
            case 'placement jig on ends of the wire':
                return this.getDiffRetainerLang('subOptions.placementJigOnEndsOfTheWire');
            case 'no placement jig':
                return this.getDiffRetainerLang('subOptions.noPlacementJig');
            default:
                return subOption || '';
        }
    }

    getSubOptionsDisplay({ retainerType, prescription, impressionType }) {
        if (!retainerType?.retainer_type) {
            return '';
        }
        const getOption = (key) => prescription[`${impressionType}${key}`] || '';
        const getDisplay = (label, options = []) => {
            const translatedOptions = options.map((opt) => this.getTranslatedSubOptions(opt)).filter(Boolean);
            return `${label} - ${translatedOptions.join(' & ')}`;
        };
        switch (retainerType?.retainer_type) {
            case 'bleachingRetainers':
                return getDisplay(retainerType.retainer_type_label, [getOption('BleachingRetainersSelect')]);
            case 'MDLSmartFitRetainersWithWire':
            case 'ecodontRetainersWithWire':
            case 'ecodontRetainerWithWire_1set':
                return getDisplay(retainerType.retainer_type_label, [getOption('WireSelect')]);
            case 'fixedPalatalWire':
                return getDisplay(retainerType.retainer_type_label, [
                    getOption('WireSelect'),
                    getOption('JigPlacementSelect'),
                ]);
            case 'ecodontRetainerWithVeneerShield_3set':
                return getDisplay(retainerType.retainer_type_label, [getOption('LowTrimlineAreaSelect_3')]);
            case 'ecodontRetainerWithVeneerShield_1set':
                return getDisplay(retainerType.retainer_type_label, [getOption('LowTrimlineAreaSelect_1')]);
            default:
                return retainerType.retainer_type_label || '';
        }
    }

    getDisplayValue(field, value, prescription, impressionType) {
        // console.log("field => ", field)
        // console.log("value => ", value)
        if (value === null || value === undefined) return '-';
        switch (field) {
            case 'FixedWire':
                if (value === 1 || value === 'true') return 'Yes';
                return 'No';
            case 'RetainerTypeId':
                if (Array.isArray(this.supportedRetainerTypes) && this.supportedRetainerTypes.length > 0) {
                    const retainerType = this.supportedRetainerTypes.find((item) => item.retainer_type_id === value);
                    const hasOpt = retainerType?.has_option === 1;
                    if (!hasOpt && retainerType) {
                        return retainerType.retainer_type_label;
                    }
                    return this.getSubOptionsDisplay({ retainerType, prescription, impressionType });
                }
                return '-';
            case 'ClearRetainerDesignUpperOption':
            case 'ClearRetainerDesignLowerOption':
            case 'ClearRetainerDesignUpperOptionForSecondSet':
            case 'ClearRetainerDesignLowerOptionForSecondSet':
                const found = archRententionOption.find((item) => item.value === value);
                if (!found) return '-';
                return this.getDiffRetainerLang(`formOptions.${found.value}`);
            case 'Pontic':
                // include all the options that are / were valid (insertAPontic & doNotInsertAPontic are deprecated but still need to be displayed)
                const isValid = [
                    'insertAPontic',
                    'doNotInsertAPontic',
                    'sectionTheWireToIgnoreTheSpace',
                    'colourPonticRequired',
                    'noPonticColour',
                ].includes(value);
                if (!isValid) return '-';
                return this.getDiffRetainerLang(`formQuestionLabel.${value}`);
            default:
                return value || '-';
        }
    }
}
